import { Controller } from '@hotwired/stimulus';
import { trackEvent } from '../analytics';
import { markWentToStore, storeParams } from './helpers/extension_store';

// Counts every trip to a web store, wherever the button lives — the install tracker only runs on pages
// rendering the install panel, so it can't own this. Fire-and-forget: the store opens in a new tab.
export default class extends Controller {
  static values = { event: String, surface: String, signedIn: Boolean };

  // The action sits on a wrapper so every store variant is covered, so ignore clicks that missed the link
  // itself — surrounding whitespace, and the unsupported-browser notice that ships in the same wrapper.
  clicked(event) {
    if (!event.target.closest('a')) return;

    trackEvent(this.eventValue, { ...storeParams(), surface: this.surfaceValue, signed_in: this.signedInValue });
    markWentToStore();
  }
}
